export default __webpack_public_path__ + "static/media/booklet.bbabc584.png";